import React from 'react';

import { CMSLink } from '@/components/Link';
import { LinkAppearances } from '@/fields/link';
import type { ButtonGroupBlock as ButtonGroupBlockProps } from '@/payload-types';
import { cn } from '@/utils/cn';

import styles from './block.module.scss';

export const ButtonGroupBlock: React.FC<ButtonGroupBlockProps> = (props) => {
  const { alignment, buttons, tracking } = props;

  if (!buttons || !Array.isArray(buttons) || buttons.length === 0) {
    return null;
  }

  return (
    <div className={cn(styles.group, alignment && styles[alignment])}>
      {buttons.map((button, index) => {
        const { link } = button;
        const adjustedLink = {
          ...link,
          appearance: link.appearance as LinkAppearances | undefined,
        };

        if (
          !adjustedLink.label ||
          (!adjustedLink.url && !adjustedLink.reference)
        ) {
          return null;
        }

        return (
          <CMSLink
            key={index}
            tracking={{
              type: 'Button Group',
              headline: tracking?.cta || '',
              cta: adjustedLink.label,
            }}
            {...adjustedLink}
          />
        );
      })}
    </div>
  );
};
